import api from '@/components/mixins/baseApi';

export default {
  mixins: [api],
  methods: {
    getSponsorshipList(page = null) {
      this.$store.commit('setProgressVal', 1);
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/sponsorship/page/${page ? `${page}` : '1'}`,
        onDownloadProgress: (progressEvent) => {
          this.$store.commit('setProgressVal', Math.round(progressEvent.progress * 100));
        },
      })
        .then((data) => {
          this.$store.commit('setProgressVal', 100);
          return data;
        })
        .catch((error) => {
          this.$store.commit('setProgressVal', 100);
          return Promise.reject(error);
        });
    },
  },
};
